export const HOST_NAME = "[Kale MFE Host]";
